module.exports = __webpack_public_path__ + "img/veza-5NP.a08b88d8.png";